import React from "react";
import {
  UncontrolledDropdown,
  DropdownMenu,
  DropdownToggle,
  Spinner,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import { DASHBOARD_TYPE, DASHBOARD_URL_BY_TYPE } from "src/constant/common";
import TooltipWrapper from "src/components/Common/TooltipWrapper";

const SeriesMultiDashboard = ({
  id,
  isLoading,
  isShow = true,
  serieData,
  isSensitivityAnalysis,
  isDispersionAnalysis,
  isFragmentAnalysis,
  isDebrisImpactAnalysis,
  getDashboardItemByType,
  handleClickGetDashboardUrl,
  isMCSDashboard
}) => {
  const { t } = useTranslation("flight-simulator");

  const isDashboardUrlAvailable = (type) => {
    const dashboardItem = getDashboardItemByType(serieData, type);
    if (dashboardItem?.[DASHBOARD_URL_BY_TYPE[type]]) {
      return true;
    }
    return false;
  }

  const debrisImpactDashboardType = isDebrisImpactAnalysis ? DASHBOARD_TYPE.DEBRIS_IMPACT : DASHBOARD_TYPE.FRAGMENT_ANALYSIS;

  const isMultiDashboardAvailable = () => (isDebrisImpactAnalysis || isDashboardUrlAvailable(DASHBOARD_TYPE.MAIN)) && (
    isDashboardUrlAvailable(DASHBOARD_TYPE.SENSITIVITY) || (
      isDashboardUrlAvailable(DASHBOARD_TYPE.DISPERSION_ERROR) &&
      isDashboardUrlAvailable(DASHBOARD_TYPE.DISPERSION_RSS)
    ) || (
      isDashboardUrlAvailable(DASHBOARD_TYPE.MCS_TRIMMING) &&
      isDashboardUrlAvailable(DASHBOARD_TYPE.MCS_STATISTICAL)
    ) || isDashboardUrlAvailable(debrisImpactDashboardType)
  );

  return (
    isShow ? (
      isLoading ? (
        <Spinner size="sm" color="secondary" className="mx-1" />
      ) : (
        <TooltipWrapper
          tooltipText={t("list.table.dashboard")}
          id={`dashboard-serie-${id}`}
        >
          <UncontrolledDropdown
            className="align-self-center"
            id={`dashboard-serie-${id}`}
          >
            <DropdownToggle
              data-toggle="dropdown"
              tag="button"
              className="border-0 bg-transparent"
            >
              <i className={`bi bi-speedometer2 ${isMultiDashboardAvailable() ? 'text-success' : 'text-dark'} f-s-20`} />
            </DropdownToggle>

            <DropdownMenu container=".navbar">
              {!isDebrisImpactAnalysis && (
                <div
                  role="button"
                  className={`dropdown-item ${isDashboardUrlAvailable(DASHBOARD_TYPE.MAIN) ? 'text-success' : 'text-dark'}`}
                  onClick={() => handleClickGetDashboardUrl(DASHBOARD_TYPE.MAIN)}
                >
                  <span>{t('list.table.flight_analysis_dashboard')}</span>
                </div>
              )}
              {isFragmentAnalysis && (
                <div
                  role="button"
                  className={`dropdown-item ${isDashboardUrlAvailable(debrisImpactDashboardType) ? 'text-success' : 'text-dark'}`}
                  onClick={() => handleClickGetDashboardUrl(debrisImpactDashboardType)}
                >
                  <span>{t('list.table.fragment_analysis_dashboard')}</span>
                </div>
              )}
              {isSensitivityAnalysis && (
                <div
                  role="button"
                  className={`dropdown-item ${isDashboardUrlAvailable(DASHBOARD_TYPE.SENSITIVITY) ? 'text-success' : 'text-dark'}`}
                  onClick={() => handleClickGetDashboardUrl(DASHBOARD_TYPE.SENSITIVITY)}
                >
                  <span>{t('list.table.sensitivity_analysis_dashboard')}</span>
                </div>
              )}

              {isDispersionAnalysis && (
                <>
                  <div
                    role="button"
                    className={`dropdown-item ${isDashboardUrlAvailable(DASHBOARD_TYPE.DISPERSION_ERROR) ? 'text-success' : 'text-dark'}`}
                    onClick={() => handleClickGetDashboardUrl(DASHBOARD_TYPE.DISPERSION_ERROR)}
                  >
                    <span>{t('list.table.dispersion_error_dashboard')}</span>
                  </div>
                  <div
                    role="button"
                    className={`dropdown-item ${isDashboardUrlAvailable(DASHBOARD_TYPE.DISPERSION_RSS) ? 'text-success' : 'text-dark'}`}
                    onClick={() => handleClickGetDashboardUrl(DASHBOARD_TYPE.DISPERSION_RSS)}
                  >
                    <span>{t('list.table.dispersion_rss_dashboard')}</span>
                  </div>
                </>
              )}
              {isMCSDashboard && (
                <>
                  <div
                    role="button"
                    className={`dropdown-item ${isDashboardUrlAvailable(DASHBOARD_TYPE.MCS_TRIMMING) ? 'text-success' : 'text-dark'}`}
                    onClick={() => handleClickGetDashboardUrl(DASHBOARD_TYPE.MCS_TRIMMING)}
                  >
                    <span>{t('list.table.msc_trimming_dashboard')}</span>
                  </div>
                  <div
                    role="button"
                    className={`dropdown-item ${isDashboardUrlAvailable(DASHBOARD_TYPE.MCS_STATISTICAL) ? 'text-success' : 'text-dark'}`}
                    onClick={() => handleClickGetDashboardUrl(DASHBOARD_TYPE.MCS_STATISTICAL)}
                  >
                    <span>{t('list.table.msc_statistical_dashboard')}</span>
                  </div>
                </>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
        </TooltipWrapper>
      )
    ) : null
  );
};

export default SeriesMultiDashboard;
